import { render, staticRenderFns } from "./HelpCenter.vue?vue&type=template&id=6c4d14ae&scoped=true&lang=pug&"
import script from "./HelpCenter.vue?vue&type=script&lang=js&"
export * from "./HelpCenter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c4d14ae",
  null
  
)

export default component.exports